import React, { useEffect, useState } from "react";
import { usePermitted } from "../../common/components/permissions/permissions";
import TabbedContainer from "../../App/components/common/TabbedContainer";
import TradingMarketAdmin from "./tradingMarkets/tradingMarketAdmin";
import { useTranslation } from "react-i18next";

const TradingAdmin = () => {
  const [activeTab, setActiveTab] = useState(null);
  const queryTradingMarkets = usePermitted(["api-query-market-control"]);
  const manageTradingMarkets = usePermitted(["api-manage-market-control"]);
  const { t } = useTranslation(["trading"]);
  const tabs = [
    queryTradingMarkets && {
      id: "1",
      label: t("TradingMarkets"),
      content: <TradingMarketAdmin allowEdit={manageTradingMarkets} />,
    },
  ].filter(Boolean);
  const firstTabId = tabs[0]?.id;
  const hasActiveTab = tabs.some((tab) => tab.id === activeTab);

  useEffect(() => {
    if (firstTabId && !hasActiveTab) {
      setActiveTab(firstTabId);
    }
  }, [firstTabId, hasActiveTab]);

  return (
    <TabbedContainer
      activeTab={activeTab ?? firstTabId ?? ""}
      onTabChange={setActiveTab}
      tabs={tabs}
    />
  );
};

export default TradingAdmin;